function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(180, 210, 230)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'brown': 'rgb(84, 65, 52)','oak': 'rgb(229, 201, 174)','oyster': 'rgb(237, 206, 165)','dark-green': 'rgb(34, 102, 83)','golden-yellow': 'rgb(254, 186, 69)','solid-white-blend': 'rgb(255, 255, 255)','heather-navy': 'rgb(14, 29, 66)','dark-grey-heather': 'rgb(43, 43, 43)','heather-slate': 'rgb(85, 117, 137)','heather-mauve': 'rgb(178, 115, 111)','solid-black-blend': 'rgb(12, 12, 12)','black': 'rgb(13, 13, 13)','military-green': 'rgb(106, 108, 84)','storm': 'rgb(116, 110, 114)','peach': 'rgb(248, 188, 159)','forest': 'rgb(28, 55, 39)','heather-forest': 'rgb(79, 85, 73)','kelly': 'rgb(14, 123, 78)','athletic-heather': 'rgb(170, 161, 162)','heather-dust': 'rgb(229, 217, 201)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
